var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"select",attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},_vm._l((_vm.options),function(opt){return _c('option',{key:opt.value,domProps:{"value":opt.value}},[_vm._v(" "+_vm._s(opt.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }